import $ from 'jquery';
import GaTracking from '../core/components/ga-tracking';
export default class Collapse {
    static expandedCollapses = [];
    static trackCollapseExpandElementSelector = '.js__track-collapse-expand';
    static trackCollapseClickElementSelector = '.js__track-collapse-click';
    static init() {
        this.expandedCollapses = this.getExpandedCollapsesQueryParameters() || [];
        this.showCollapses(this.expandedCollapses);
        $('.js__init-resize-on-expand').on('shown.bs.collapse', () => {
            window.dispatchEvent(new Event('resize'));
        });
        $('.js__save-expanded-collapse')
            .on('shown.bs.collapse', e => {
            const collapseId = $(e.currentTarget).attr('id');
            if (collapseId && this.expandedCollapses.indexOf(collapseId) === -1) {
                this.expandedCollapses.push(collapseId);
            }
            this.setUrlByExpandedCollapses();
        })
            .on('hidden.bs.collapse', e => {
            const collapseId = $(e.currentTarget).attr('id');
            if (collapseId) {
                const index = this.expandedCollapses.indexOf(collapseId);
                if (index > -1) {
                    this.expandedCollapses.splice(index, 1);
                }
            }
            this.setUrlByExpandedCollapses();
        });
        this.initGaCollapseTracking();
        this.initGaCollapseClickTracking();
    }
    static showCollapses(collapseIds) {
        collapseIds.forEach(id => {
            $(`#${id}`).collapse('show');
        });
    }
    static initGaCollapseTracking() {
        const $element = $(this.trackCollapseExpandElementSelector);
        $element.on('shown.bs.collapse', e => {
            if ($(e.currentTarget).attr('id') === e.target.id) {
                this.onEventAction(e, $element);
            }
        });
    }
    static initGaCollapseClickTracking() {
        const $element = $(this.trackCollapseClickElementSelector);
        $element.on('click', e => {
            this.onEventAction(e, $element.filter(`[data-collapse-group-name="${$(e.currentTarget).data('collapse-group-name')}"]`));
        });
    }
    static onEventAction(e, $element) {
        const $collapse = $(e.currentTarget);
        const orderNumberParameterName = $collapse.data('order-number-parameter-name');
        let orderNumber = 1;
        $element.each((index, element) => {
            $(element).attr('id');
            if ($(element).attr('id') === $collapse.attr('id')) {
                orderNumber = index + 1;
            }
        });
        let dataLayer = $collapse.data('data-layer');
        if (orderNumberParameterName) {
            dataLayer = { ...$collapse.data('data-layer'), [orderNumberParameterName]: orderNumber };
        }
        if (dataLayer.eventLabel) {
            dataLayer.eventLabel = dataLayer.eventLabel.replace('%orderNumber%', orderNumber);
        }
        GaTracking.pushDataLayer(dataLayer);
    }
    static getExpandedCollapsesQueryParameters() {
        const urlParams = new URLSearchParams(window.location.search);
        const parameter = urlParams.get('expandedCollapses');
        return parameter ? parameter.split(',') : [];
    }
    static getAllQueryParameters() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        return Object.fromEntries(urlSearchParams.entries());
    }
    static setUrlByExpandedCollapses() {
        const hash = window.location.hash;
        const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${new URLSearchParams({
            ...this.getAllQueryParameters(),
            expandedCollapses: this.expandedCollapses.join(','),
        }).toString()}${hash}`;
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }
}
